import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { Box, VStack } from '@cbhq/cds-web/layout';
import type { Environment } from '@cbhq/idv-sdk-web';
import IdvSDK from '@cbhq/idv-sdk-web';

const environment = (process.env.TARGET_ENV ?? 'development') as Environment;

// Force a persistent scrollbar (rather than overflow: auto's OS-dependent
// hide-until-hover behavior) so content taller than the viewport stays
// reachable — most noticeable in in-app browsers (Facebook, Instagram, etc.)
// which often render with a shrunk, non-resizable viewport. Applied
// unconditionally since it's a no-op when content already fits. Lives on
// this shared VStack, not a vendor-specific capture component, since it
// wraps IdvSDK regardless of which capture SDK (Onfido/Persona) renders
// inside it.
const scrollableStyle = { overflowY: 'scroll', boxSizing: 'border-box' } as const;

const routeJustifyContent = {
  desktop: 'center',
  tablet: 'flex-start',
  phone: 'flex-start',
} as const;

const routeHeight = { desktop: '100dvh' } as const;

const routeMinHeight = { tablet: '100dvh', phone: '100dvh' } as const;

const routePaddingTop = {
  desktop: 3,
  tablet: 6,
  phone: 6,
} as const;

export function TokenRoute() {
  const { token } = useParams();

  if (!token) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <VStack
        alignItems="center"
        justifyContent={routeJustifyContent}
        height={routeHeight}
        minHeight={routeMinHeight}
        padding={3}
        paddingTop={routePaddingTop}
        testID="idv-token-route"
        style={scrollableStyle}
      >
        <Box
          width="100%"
          maxWidth={600}
          flexGrow={1}
          display="flex"
          flexDirection="column"
          minHeight={0}
        >
          <IdvSDK token={token} environment={environment} locale="en" />
        </Box>
      </VStack>
    </Suspense>
  );
}
